import React from 'react';
import { bool } from 'prop-types';

import { selectedAddOnProps } from 'apps/build_your_plan/store/PlanStore';
import { TranslatedMessage } from 'common/components/Intl';
import PriceSpan from 'common/components/formatters/PriceSpan';
import LineItem from 'common/components/shop/LineItem';
import LineItemPrice from 'common/components/shop/LineItemPrice';
import { getOfferingPrice } from '../../product/util/offerings';

const AddOnReviewLineItem = ({ addOn, strikethroughPrices }) => {
  const details = (
    <TranslatedMessage
      id="cart.price_each"
      values={{
        price: <PriceSpan amount={addOn.product.price} />,
      }}
    />
  );

  const price = addOn.offering.commitmentReward ? (
    <LineItemPrice
      originalPrice={addOn.product.price * addOn.quantity}
      price={getOfferingPrice(addOn.product, addOn.offering) * addOn.quantity}
      strikethrough={strikethroughPrices}
    />
  ) : (
    <LineItemPrice
      price={addOn.product.price * addOn.quantity}
      strikethrough={strikethroughPrices}
    />
  );

  return (
    <LineItem
      className="build-your-plan-review__item"
      details={details}
      imageUrl={addOn.product.src}
      key={addOn.offering.variantSku}
      name={addOn.product.title}
      price={price}
      quantity={addOn.quantity}
      quantityControls={false}
    />
  );
};

AddOnReviewLineItem.propTypes = {
  addOn: selectedAddOnProps,
  strikethroughPrices: bool.isRequired,
};

export default AddOnReviewLineItem;
